import React from 'react';
import PieGraph from './pieGraph.js';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import { Section } from 'bloomer/lib/layout/Section';
import Bold from '../Bold';

export default function HumanContributionBreakdown({
	startDate,
	endDate,
	totalTime,
	humanEffort,
	humanEffortAcc
}) {
	return (
		<Box className="on-print-own-page">
			<Title tag="h3">Human Type Breakdown:</Title>
			<Section>
			<Title tag="h3">Staff Vs. Volunteer:</Title>
				<p>
					Between <Bold>{startDate}</Bold> and{' '}
					<Bold>{endDate}</Bold> the{' '}
					<span className="is-capitalized">
						{humanEffort[0] ? humanEffort[0].label : null}
					</span>{' '}
					was{' '}
					<Bold>
						{humanEffort[0] ?
							(humanEffort[0].value / totalTime * 100).toFixed(2) :
							null}%
					</Bold>{' '}
					of total enrichment time, while the{' '}
					<span className="is-capitalized">
						{humanEffort[1] ? humanEffort[1].label : null}
					</span>{' '}
					was{' '}
					<Bold>
						{humanEffort[1] ?
							(humanEffort[1].value / totalTime * 100).toFixed(2) :
							null}%
					</Bold>{' '}
				</p>
				<PieGraph
					totalTime={totalTime}
					data={humanEffort}
					chartName="humanBreakdown"
					humanEffortAcc={humanEffortAcc}
				/>
			</Section>
		</Box>
	);
}
